import styled, { css } from 'styled-components';

export const Link = styled.a(
  () => css`
    color: inherit;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  `,
);

export const ListItem = styled.li<{ $active: boolean }>(
  ({ theme, $active }) =>
    $active &&
    css`
      color: ${theme.co.primary40};
    `,
);

export const Navigation = styled.nav(() => css``);

export const OrderedList = styled.ol(
  ({ theme }) => css`
    margin: unset;
    padding-left: ${theme.sz.s7};
    ${theme.typography.heading.desktop.xxs}
  `,
);

export const TableOfContents = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: ${theme.sz.md};
    height: fit-content;
    overflow-y: auto;
    padding-top: ${theme.sz.s6};
    padding-bottom: ${theme.sz.s6};
    background: ${theme.co.secondary20};
    box-shadow: 0 0 0 100vmax ${theme.co.secondary20};
    clip-path: inset(0 -100vmax);
    color: ${theme.co.neutral99};

    @media (min-width: ${theme.sz.md}) {
      padding-left: ${theme.sz.s10};
      padding-right: ${theme.sz.s6};
      border-radius: ${theme.bo.medium};
      box-shadow: unset;
      clip-path: unset;
    }

    @media (min-width: ${theme.sz.xxl}) {
      max-height: calc(100vh - ${theme.sz.s44});
      padding: ${theme.sz.s6};
      position: sticky;
      top: 152px; // header height + desktop indent
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
    ${theme.typography.heading.mobile.s};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.s};
    }
  `,
);

export const UnorderedList = styled.ul(
  ({ theme }) => css`
    margin: unset;
    margin-top: ${theme.sz.s4};
    padding: unset;
    list-style: none;
    ${theme.typography.heading.desktop.xxs};
  `,
);
